import React from 'react';

import { TableRow } from '@material-ui/core';

export default function HeaderRow({ row, children, ...props }) {
    return <TableRow {...props}>{children}</TableRow>;
}
